// Словарь части 5.5 «ИИ в проекте»: ТЗ проекта и черновики от ИИ — ТЗ по спецификации и задачи этапа. Подключается в
// `ru.ts` поверх словаря производства.

/** ТЗ и черновики ИИ в проекте (ключи `projects.*`). */
export const ruProjectsAi = {
  tz: {
    title: 'Техническое задание',
    lead: 'По ТЗ команда работает, а клиент принимает работу. Черновик собирает ИИ из подписанной спецификации, брифа сделки и задач проекта — проверьте и поправьте',
    emptyTitle: 'ТЗ пока нет',
    emptyText: 'Соберите черновик с ИИ или напишите ТЗ сами',
    write: 'Написать вручную',
    draft: 'Черновик ТЗ с ИИ',
    redraft: 'Пересобрать с ИИ',
    placeholder: 'Цели, состав работ, требования, критерии приёмки, что не входит',
    edit: 'Править',
    save: 'Сохранить',
    cancel: 'Отменить правки',
    saved: 'ТЗ сохранено',
    updated: 'Изменено {date} · {name}',
    readOnly: 'ТЗ правит руководитель проекта',
    draftTitle: 'Черновик ТЗ от ИИ',
    draftLead: 'Поправьте текст прямо здесь и примите. Принятый черновик заменит текущее ТЗ',
    accept: 'Принять',
    discard: 'Отклонить',
    accepted: 'ТЗ принято',
    sections: {
      goals: 'Цели',
      scope: 'Состав работ',
      requirements: 'Требования',
      acceptance: 'Критерии приёмки',
      outOfScope: 'Что не входит',
    },
    result: 'Черновик ТЗ готов — он ниже, проверьте и примите',
  },
  ai: {
    draftTasks: 'Задачи с ИИ',
    draftTasksHint: 'ИИ предложит задачи этапа по ТЗ, спецификации и брифу',
    emptyStage: 'Задач нет — сгенерировать из спецификации',
    title: 'Черновик задач: {stage}',
    lead: 'Отметьте нужные задачи — они добавятся в этап. Неотмеченные пропадут',
    selectAll: 'Выбрать все',
    selectNone: 'Снять все',
    complexity: 'Сложность {value}',
    selected: 'Выбрано {count} · {hours}',
    contract: 'По договору {contract} · в этапе уже {planned}',
    noContract: 'У этапа нет договорных часов — сравнить не с чем',
    overTitle: 'Сверх договора?',
    overText:
      'С выбранными задачами этап больше договора на {hours}. Отметьте их «Сверх договора» — из таких задач собирается допсоглашение',
    markExtra: 'Отметить «Сверх договора»',
    add: {
      one: 'Добавить {count} задачу',
      few: 'Добавить {count} задачи',
      many: 'Добавить {count} задач',
      other: 'Добавить {count} задачи',
    },
    tasksAdded: {
      one: 'В этап добавлена {count} задача',
      few: 'В этап добавлены {count} задачи',
      many: 'В этап добавлено {count} задач',
      other: 'В этап добавлено {count} задачи',
    },
    result: {
      one: 'ИИ предложил {count} задачу',
      few: 'ИИ предложил {count} задачи',
      many: 'ИИ предложил {count} задач',
      other: 'ИИ предложил {count} задачи',
    },
    review: 'Посмотреть и добавить',
    noneSelected: 'Отметьте хотя бы одну задачу',
    notLead: 'Запускать ИИ может руководитель проекта',
    closed: 'Проект в архиве или сдан — ИИ не запускается',
  },
} as const;

/** Подсказки «i» 5.5 (в `projects.hints`). */
export const ruProjectsAiHints = {
  tz: {
    title: 'ТЗ проекта',
    text: 'Черновик ТЗ ИИ собирает из подписанной спецификации (пакет, этапы и их результат), брифа сделки и задач проекта. Контакты, часы и суммы в ИИ не уходят. Черновик ничего не меняет, пока вы его не примете',
    example: 'Цели — «запустить продажи онлайн»; критерии приёмки — «заказ оформляется с телефона за 3 шага»',
  },
  aiTasks: {
    title: 'Задачи с ИИ',
    text: 'ИИ разбивает этап на задачи: название, специализация, сложность, часы и описание. Добавляются только отмеченные. Если с ними этап больше договорных часов (задачи из подписанной сметы), подскажем отметить их «Сверх договора»',
    example: 'Этап «Вёрстка» по договору 80 ч, в нём уже 72 ч, выбрано ещё 16 ч — сверх договора 8 ч',
  },
} as const;
